export default __webpack_public_path__ + "static/secImgRight-44ff1b77dc6a7f2c05daabfb942d2303.png";